export default Object.freeze({
  INTRO: {
    PART1: 'Sign',
    PART2: 'Certificates and Documents',
    PART3: 'virtually',
    PART4: 'and',
    PART5: 'safely!',
  },
  MOBILE_VIEW:
    'SigNit is currently best suited for work on a desktop or laptop. We encourage you to use it via the same.',
});
